import Vue from 'vue';
import ItemTips from './itemTips.vue'

let DialogConstructor = Vue.extend(ItemTips) // 构造函数
let instance // 实例对象

const Item_Tips = (options = {}) => {

//if(GLOBAL.deviceType == 'pc')return;

if (typeof options === 'string') {
        options = {
            item_id: options
        }
    }

  instance = new DialogConstructor({
    data: options
  })
  
  instance.vm = instance.$mount()
  document.body.appendChild(instance.vm.$el)
  instance.vm.visible = true
  instance.dom = instance.vm.$el
  return instance.vm
}

export default Item_Tips


// WEBPACK FOOTER //
// ./src/components/ItemTips/index.js